<div class="container">
    <ul class="block-brands__list">
        <ng-container *ngFor="let brand of data">
            <li class="block-brands__item">
                <a class="block-brands__item-link">
                    <img [src]="brand.icon" alt="">

                    <span class="block-brands__item-name">{{ brand.name }}</span>
                </a>
            </li>
            <li class="block-brands__divider" role="presentation"></li>
        </ng-container>
    </ul>
</div>
